module.exports = __webpack_public_path__ + "img/tips1.e84a082d.png";